<template lang="pug">
  div.containerInfo
      el-row(:gutter="20").margin.mb-20
        el-col.inputDiv(:span="6")
          app-label(label="CNUC", :required="true")
          el-input.input(
            v-model="informacoesAdministrativas.cnuc"
            type="text"
            placeholder="Digite o CNUC"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Nome da Unidade de Conservação", :required="true")
          el-input.input(
            v-model="informacoesAdministrativas.nomeUc"
            type="text"
            placeholder="Digite o nome da unidade de conservação"
          )
        el-col.inputDiv(:span="8")
          app-label(label="Esfera Administrativa", :required="true")
          el-select.full-width(v-model="informacoesAdministrativas.esferaAdministrativa" placeholder="Selecione a esfera administrativa")
            el-option(
              v-for="item in optionsEsfera"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
        el-col.inputDiv(:span="24")
          app-label(label="Objetivo da Criação da UC", :required="true")
          el-input.input(
            v-model="informacoesAdministrativas.objetivoCriacaoUc"
            type="textarea"
            placeholder="Digite o objetivo (até 2000 caracteres)"
            rows="4"
          )
        el-col.inputDiv(:span="6")
          app-label(label="Órgão Gestor", :required="true")
          el-input.input(
            v-model="informacoesAdministrativas.orgaoGestor"
            type="text"
            placeholder="Digite o órgão gestor"
          )
        el-col.inputDiv(:span="24")
          app-label(label="Categoria de Manejo", :required="true")
          el-radio-group(v-model="informacoesAdministrativas.tipoUc")
            el-radio(:label="'ProtecaoIntegral'") UCs de proteção integral
            el-radio(:label="'UsoSustentavel'") UCs de uso sustentável
      el-row(:gutter="20", v-if="informacoesAdministrativas.tipoUc === 'ProtecaoIntegral'").margin.mb-20
        el-col.inputDiv(:span="12")
          app-label(label="Tipo de UC de Proteção Integral", :required="true")
          el-select.full-width(v-model="informacoesAdministrativas.tipoUcProtecaoIntegral" placeholder="Selecione o tipo de UC de proteção integral")
            el-option(
              v-for="item in optionsProtecaoIntegral"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
      el-row(v-if="informacoesAdministrativas.tipoUc === 'UsoSustentavel'" :gutter="20").margin.mb-20
        el-col.inputDiv(:span="8")
          app-label(label="Tipo de UC de Uso Sustentável", :required="true")
          el-select.full-width(v-model="informacoesAdministrativas.tipoUcUsoSustentavel" placeholder="Selecione o tipo de UC de uso sustentável")
            el-option(
              v-for="item in optionsUsoSustentavel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            )
</template>

<script>
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppLabel
  },
  props: {
    informacoes: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      informacoesAdministrativas: { ...this.informacoes },
      optionsEsfera: [
        { value: 'Federal', label: 'Federal' },
        { value: 'Estadual', label: 'Estadual' },
        { value: 'Municipal', label: 'Municipal' }
      ],
      optionsProtecaoIntegral: [
        { value: 'EstacaoEcologica', label: 'Estação ecológica' },
        { value: 'ReservaBiologica', label: 'Reserva biológica' },
        { value: 'ParqueNacional', label: 'Parque nacional' },
        { value: 'MonumentoNatural', label: 'Monumento natural' },
        { value: 'RefugioVidaSilvestre', label: 'Refúgio da vida silvestre' }
      ],
      optionsUsoSustentavel: [
        { value: 'APA', label: 'Área de proteção ambiental (APA)' },
        { value: 'ARIE', label: 'Área de relevante interesse ecológico (ARIE)' },
        { value: 'FLONA', label: 'Floresta nacional (FLONA)' },
        { value: 'RESEX', label: 'Reserva extrativista (RESEX)' },
        { value: 'ReservaFauna', label: 'Reserva de fauna' },
        { value: 'RDS', label: 'Reserva de desenvolvimento sustentável (RDS)' },
        { value: 'RPPN', label: 'Reserva particular do patrimônio natural (RPPN)' }
      ]
    }
  },
  methods: {
    onTipoUcChange () {
      return this.informacoesAdministrativas.tipoUc
    },
    handleTipoUcProtecaoIntegral () {
      return this.informacoesAdministrativas.tipoUcProtecaoIntegra
    },
    handleTipoUcUsoSustentavel () {
      return this.informacoesAdministrativas.tipoUcUsoSustentavel
    }
  },
  watch: {
    informacoesAdministrativas: {
      handler (newVal) {
        this.$emit('update:informacoes', newVal)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.mb-20 {
  margin-bottom: 20px;
}
.margin.mb-20 {
  margin-bottom: 20px;
}
.el-row {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 20px;
}

.radio-label {
  margin-bottom: 8px;
  margin-top: 10px;
}
.label-text {
  font-weight: bold;
  margin-top: 5px;
}
.label-wrapper {
  margin-bottom: 20px;
}
.full-width {
  width: 95%;
}
.containerInfo {
  min-height: 65vh;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppFormularioInformacoesAdministrativas.vue